import builder from '../builder';
import SocialMediaFacebook1 from '../../streamline-icons/bold/social-media-facebook-1.svg';

export default builder('IconSocialMediaFacebook1Bold', SocialMediaFacebook1);
